import { render, staticRenderFns } from "./CommentViewer.vue?vue&type=template&id=60c172ef"
import script from "./CommentViewer.vue?vue&type=script&lang=js"
export * from "./CommentViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports